import sendRequest from "@/utils/request"

export const URLS = {
  GetToken: "/api/Auth/GetToken",
  logout: "/api/user/logout",
  GetDefaultReportTemplateList: "/api/CommonBill/GetDefaultReportTemplateList",
  Login: "api/PcClient/AdminAuth/Login",
  GetCorpId: "api/PcClient/AdminAuth/GetCorpId",
  GetPermissions: "/api/PcClient/AdminAuth/GetPermissions",
  QueryMyPermissions:
    "/api/DirectorClient/PermissionDirectorQuery/QueryMyPermissions",
  QueryEnumDef: "/api/Common/Enum/QueryEnumDef",
}

const apis = {}
for (const key in URLS) {
  const url = URLS[key]
  apis[key] = (params, option = {}) => {
    return sendRequest(url, params, "post", option)
  }
}
export default apis
